import React from "react";
import PropTypes from "prop-types";
import ContentKeyItem from "../ContentKeyItem";
import { KeyList } from "./_.styled";

const ContentKeyList = ({ keys, isMobile }) => (
  <>
    {keys && (
      <KeyList isMobile={isMobile}>
        {keys.map((key) => (
          <ContentKeyItem key={key.value} {...key} />
        ))}
      </KeyList>
    )}
  </>
);

ContentKeyList.propTypes = {
  keys: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      icon: PropTypes.shape({
        glyph: PropTypes.string.isRequired,
        color: PropTypes.string.isRequired,
        size: PropTypes.string.isRequired,
        testId: PropTypes.string.isRequired,
      }),
      testId: PropTypes.string.isRequired,
      style: PropTypes.string,
      value: PropTypes.string.isRequired,
    })
  ),
  isMobile: PropTypes.bool,
};

ContentKeyList.displayName = "ContentKeyList";

export default ContentKeyList;
